import { render, staticRenderFns } from "./BindingCard.vue?vue&type=template&id=f49cd22e&scoped=true"
import script from "./BindingCard.vue?vue&type=script&lang=js"
export * from "./BindingCard.vue?vue&type=script&lang=js"
import style0 from "./BindingCard.vue?vue&type=style&index=0&id=f49cd22e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49cd22e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f49cd22e')) {
      api.createRecord('f49cd22e', component.options)
    } else {
      api.reload('f49cd22e', component.options)
    }
    module.hot.accept("./BindingCard.vue?vue&type=template&id=f49cd22e&scoped=true", function () {
      api.rerender('f49cd22e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mine/BindingCard.vue"
export default component.exports